import { render } from "./EdoDocumentIntegrationCard.vue?vue&type=template&id=3cdcfe9a"
import script from "./EdoDocumentIntegrationCard.vue?vue&type=script&lang=js"
export * from "./EdoDocumentIntegrationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__